<template>
  <div class="noprescription paddingtop">
    <h2 style="text-align:center;">过敏史</h2>
    <van-cell-group :border="false">
        <van-field
            v-model="allergy"
            class="remark-area"
            type="textarea"
            show-word-limit
            :maxlength="50"
            rows="3"
            autosize
            placeholder="请输入过敏史..."
        />
    </van-cell-group>
    <div class="footerbut">
      <van-button
        round
        block
        type="danger"
        :color="butcolor"
        text="完成"
        @click="onCompelete()"
      />
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { diagnostics } from '@/api/index'
import { getCookie } from '@/utils/auth'
import {trim} from '@/utils/index.js'
export default {
  props: {
    len:Number,
    addMainSuit:Function
  },
  data() {
    return {
      butcolor: '#01B956', // 按钮颜色
      allergy:''
    }
  },
  
  created() {

  },
  methods:{
    onCompelete(){
      if(this.allergy.trim().length===0){
        this.$toast({
          message:'无效字符'
        })
        this.allergy = ''
        return false
      }
      if(this.allergy.length+this.len>50){
        this.$toast({
          message:'过敏史总字数不可超过50字'
        })
        return false
      }
      this.$emit('addAllergy',this.allergy.trim())
      this.allergy = ''
    }
  }
}
</script>
<style scoped lang="scss">

.noprescription > h2 {
  padding: 15px;
  font-size: 16px;
  margin: 0;
}
.search-box {
  padding: 0 15px;
  left: 0;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 1005;
  .search-box_input {
    flex: 1;
    padding: 0;
    background: #fff !important;
    .van-search__content {
      background: #f7f8fa;
    }
  }
}

.footerbut {
  padding: 15px 20px;
  /deep/ .van-button__text {
    font-size: 18px;
  }
}
</style>
